var History = window.History;
var app;

// Map number x from range [a, b] to [c, d]
const map = (x, a, b, c, d) => (x - a) * (d - c) / (b - a) + c;

// Linear interpolation
const lerp = (a, b, n) => (1 - n) * a + n * b;
const clamp = (num, min, max) => num <= min ? min : num >= max ? max : num;

// Generate a random float.
const getRandomFloat = (min, max) => (Math.random() * (max - min) + min).toFixed(2);

// Gets the mouse position
const getMousePos = (e) => {
    let posx = 0;
    let posy = 0;
    if (!e) e = window.event;
    if (e.pageX || e.pageY) {
        posx = e.pageX;
        posy = e.pageY;
    }
    else if (e.clientX || e.clientY)    {
        posx = e.clientX + body.scrollLeft + document.documentElement.scrollLeft;
        posy = e.clientY + body.scrollTop + document.documentElement.scrollTop;
    }

    return { x : posx, y : posy };
};

function App() {
	var self = this;
	this.photoswipe = false;
	$(document).ready(function() {
		self.detectBrowser();
		$('body').addClass('-loading');
		gsap.registerPlugin(ScrollTrigger);
		gsap.config({force3D: true});
		self.menuOverlayOpen = false;
		self.animations = new Animations();
		self.mq = false;
		self.init();
	});
}

App.prototype.init = function() {
	var self = this;

	self.handleWindowResize();
	// self.ajaxHistory = new AjaxHistory();
	// self.filters = new Filters();
	self.scroll = new Scroll();
	
	
	$(window).on('resize', this, this.handleWindowResize.bind(self));

	sessionStorage.removeItem('backButton');
	self.handleMenu();	
	this.initModules();

	var docTitle = $(document).find('title').html();
	self.historyArr = [[$('.body-wrapper').html(), $('body').attr('class'), window.location.href, docTitle]];
	if (sessionStorage.getItem('historyArr')) {
		self.historyArr = JSON.parse(sessionStorage.getItem('historyArr'));
	} else {
		sessionStorage.setItem('historyArr', JSON.stringify(self.historyArr));
	}

	$(window).on('load', function() {
		setTimeout(function() {
			// $('body').addClass('-loaded');
			$('body').addClass('-ready');
		}, 500);
	});
};

App.prototype.initModules = function(partial) {
	var self = this;
	if (partial == ".section--cstudies-index .container") {
	} else {
		$('a').filter((i, p) => $(p).text() === "\u00a0").text('');
		self.startAnimation = false;
		self.accordions = new Accordions();
		self.photoswipe = new initPhotoSwipe();
		// self.handleFilterDropdowns();
		self.ui = new UI();
		self.slick = new Slick();
		self.animations.init();
		self.tabs = new Tabs();
		self.images = new ResponsiveBackgroundImage();
		self.handleBackButton();
		self.handlePagination();
		self.cookies = new Cookies();
		// self.banners = new Banners();
		self.overlays = new Overlays();
		self.waypoints = new Waypoints();
		self.handleWindowResize();
	}
	if (window.location.hash && $(window.location.hash).length) {
		this.scroll.scrollTo($(window.location.hash));
	}
};

App.prototype.stateChange = function() {
	var self = this;
	self.waypoints.hideItemsOnPageLoad();
};

App.prototype.handleMenu = function() {
	var self = this;
	// const elmOverlay = document.querySelector('.shape-overlays');
	// const overlay = new ShapeOverlays(elmOverlay);

	$('.header-menu-toggle').click(function(e) {
		var overlay = '.menu-overlay',
			overlayItems = '.menu-overlay-items__item[data-level="2"] > a';
		if (!$(overlay).hasClass('-opening') && !$(overlay).hasClass('-closing')) {
			if (self.menuOverlayOpen) {
				//is open
				let t1 = gsap.timeline();
				t1.to(overlayItems, {
						onStart: function() {$(overlay).removeClass('-active').addClass('-closing');},
						onComplete: function() {$(overlay).removeClass('-closing');},
						// y: "150%",
						duration: 0.35,                
                		stagger: 0.01,
                		ease: "power2"
					}
				);
				self.menuOverlayOpen = false;
			} else {
				//is closed
				let t1 = gsap.timeline();
				t1.to(overlay, {
						onStart: function() {$(overlay).removeClass('-closing').addClass('-opening');},
						onComplete: function() {$(overlay).removeClass('-opening').addClass('-active');},
						duration: 0.75,
					}
				).fromTo(overlayItems, {
						y: "150%",
					}, {
						y: "0%",
						duration: 0.5,                
                		stagger: 0.0,
                		ease: "expo"
					}
				);		
				self.menuOverlayOpen = true;
			}
		}
		e.preventDefault();
	});

	// kllikanie wezla z gornego menu
	$('.header-menu li[data-children="1"] a').click(function(e) {
		var target = $(this).parent().attr('data-id');
		e.preventDefault();
		$('.header-menu-toggle').click();
		$('.menu-overlay-items li.-last').removeClass('-last');
		$('.menu-overlay-items li[data-id="'+target+'"').addClass('-active').addClass('-last');
		if (self.menuOverlayOpen) {
			$('.menu-overlay-items li.-last').delay(500).queue(function() {$(this).addClass('-anim').dequeue();});
		} else {
			$('.menu-overlay-items li.-last').removeClass('-anim');
		}
	});
	// zamykanie menu po kliknieciu linka
	$('.menu-overlay-items .menu-overlay-items__item a').click(function(e) {
		var parentList = $(this).closest('li');
		if (parentList.attr('data-children')) {
			// jesli ma dzieci
			e.preventDefault();
			$('.menu-overlay-items li.-last').removeClass('-anim');
			parentList.find('.-active').removeClass('-active');
			if (parentList.hasClass('-active')) {
				$('.menu-overlay-items li.-last').removeClass('-last');
				parentList.removeClass('-active');
				parentList.parent().parent().addClass('-active').addClass('-last').siblings().removeClass('-active');
			} else {
				$('.menu-overlay-items li.-last').removeClass('-last');
				parentList.addClass('-active').addClass('-last').siblings().removeClass('-active');
			}
			$('.menu-overlay-items li.-last').delay(100).queue(function() {$(this).addClass('-anim').dequeue();});
		} else {
			// nie ma dzieci, pojdz za linkiem i zamknij menu
			$('.header-menu-toggle').click();
		}
	});

	$('.section-switch a[href="#"]').click(function(e) {
		e.preventDefault();
	});
	$('.section-switch').click(function(e) {
		let section = $(this);
		if (!section.hasClass('-active')) {
			e.preventDefault();
			section.addClass('-active');
		}
	});
	$('.section-switch-close').click(function(e) {
		$(this).closest('.section-switch').removeClass('-active');
		return false;
	});
};

App.prototype.handleBackButton = function() {
	var self = this;

	if ($('body').hasClass('-search') || $('body').hasClass('-archive')) {
		var url = window.location.pathname+window.location.search;
		sessionStorage.setItem('backButton', url);
	} else {
		if (!$('body').hasClass('-archive-show')) {
			sessionStorage.removeItem('backButton');
		}
	}

	if (sessionStorage.getItem('backButton')) {
		$('.cstudies-show .go-back').attr('href', sessionStorage.getItem('backButton'));
	} else {
		var locale = $('html').attr('lang');
		if (locale == 'en')
			$('.cstudies-show .go-back').attr('href', '/en/archive');
		else
			$('.cstudies-show .go-back').attr('href', '/archiwum');
	}
};

App.prototype.handlePagination = function() {
	var self = this;

	$('.section[data-paginate]').each(function() {
		let target = $(this);

		function paginate(target) {
			var page = parseInt(target.attr('data-page')),
				pages = parseInt(target.attr('data-pages')),
				paginate = parseInt(target.attr('data-paginate')),
				sections = [];

			target.find('.section:not(:first-of-type):not(.section--pagination)').each(function() {
				sections.push($(this));
			});

			for (i=0; i<sections.length; i++) {
				sections[i].addClass('-hidden');
				if (page*paginate <= i && i < (page+1)*paginate)
					sections[i].removeClass('-hidden');
			}
		}

		target.find('.section--pagination a').on('click', function(e){
			e.preventDefault();
			$(this).addClass('-active').siblings().removeClass('-active');
			target.attr('data-page', $(this).attr('data-page'));
			paginate(target);
		});

		paginate(target);
	});

	$('*[data-loadmore] + .loadmore a').on('click', function(e){
		e.preventDefault();
		$(this).closest('.loadmore').prev().removeAttr('data-loadmore');
	});
};

App.prototype.handleFilterDropdowns = function() {
	var self = this;
	$('.dropdown-toggle').on('click', function(e) {
		e.preventDefault();
		$(this).closest('.w-dropdown').find('.dropdown-toggle, .w-dropdown-list').toggleClass('w--open');
	});

	$('.news-filters-left a').click(function(e) {
		e.preventDefault();
		$(this).closest('.news-filters').toggleClass('-active');
	});
};

App.prototype.handleWindowResize = function() {
	var self = this;
	let vh = window.innerHeight * 0.01,
		vw = window.innerWidth,
		hh = $('header').innerHeight(),
		dh = $('footer').innerHeight();
	document.documentElement.style.setProperty('--vh', `${vh}px`);
	document.documentElement.style.setProperty('--hh', `${hh}px`);
	document.documentElement.style.setProperty('--fh', `${dh}px`);
	if (vw <= 478) {
		self.mq = 1;
	} else if (vw <= 767) {
		self.mq = 2;
	} else if (vw <= 767) {
		self.mq = 3;
	} else if (vw <= 991) {
		self.mq = 4;
	} else if (vw <= 1279) {
		self.mq = 5;
	} else if (vw <= 1439) {
		self.mq = 6;
	} else if (vw <= 1919) {
		self.mq = 7;
	} else {
		self.mq = 8;
	}

	if (self.waypoints)
		self.waypoints.updateOnResize();
};

App.prototype.detectBrowser = function() {
	var self = this;
	if (navigator.userAgent.indexOf("Chrome") != -1 ) {
		self.browser = "chrome";
	}
	else if (navigator.userAgent.indexOf("Firefox") != -1 ) {
		self.browser = "firefox";
	}
	else if (navigator.userAgent.indexOf("MSIE") != -1 ) {
		self.browser = "msie";
	}
	else if (navigator.userAgent.indexOf("Edge") != -1 ) {
		self.browser = "edge";
	}
	else if (navigator.userAgent.indexOf("Safari") != -1 ) {
		self.browser = "safari";
	}
	else if (navigator.userAgent.indexOf("Opera") != -1 ) {
		self.browser = "opera";
	}
	else if (navigator.userAgent.indexOf("YaBrowser") != -1 ) {
		self.browser = "yabrowser";
	}
	else {
		self.browser = "other";
	}
	$('body').attr('data-browser', self.browser);
};

app = new App();